import { StatusBadge, type StatusVariant } from '@/shared/components/status-badge';

const STATUS: Record<string, { label: string; variant: StatusVariant }> = {
  open: { label: 'Open', variant: 'warning' },
  resolved: { label: 'Resolved', variant: 'success' },
  // Closed on purpose, nothing to act on: it recedes rather than alarms.
  rejected: { label: 'Rejected', variant: 'neutral' },
};

export function ComplaintStatusBadge({ status }: { status: string }) {
  const known = STATUS[status];
  return (
    <StatusBadge variant={known?.variant ?? 'neutral'}>
      {known?.label ?? status.charAt(0).toUpperCase() + status.slice(1)}
    </StatusBadge>
  );
}

/** Open, and the customer spoke last: someone on staff owes them a reply. */
export function NeedsReplyBadge() {
  return <StatusBadge variant="brand">Needs reply</StatusBadge>;
}
